export default __webpack_public_path__ + "static/pea-pod-50d742b9f63908372d55cb02a7879c0c.png";